import { Box, Alert } from '@mui/material';
import { Provider } from 'react-redux';
import type { LayoutBlock } from './types';
import Kanban from '../kanban/projectsKanban/Kanban';
import { store } from '../kanban/projectsKanban/store';
import Localization from '../kanban/shared/components/localization';
import { KanbanThemeProvider } from '../kanban/projectsKanban/styles/KanbanThemeProvider';

type DetailFormKanbanSectionProps = {
  block: LayoutBlock;
  mode: 'add' | 'edit';
};

export const DetailFormKanbanSection = ({ block, mode }: DetailFormKanbanSectionProps) => {
  if (mode === 'add') {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert severity="info">Save the parent record first to view the projects kanban.</Alert>
      </Box>
    );
  }

  return (
    <Provider store={store}>
      <Localization translationNodeKey="ZSite.Frontend.Kanban">
        <KanbanThemeProvider>
          <Kanban pageKey={block.key} />
        </KanbanThemeProvider>
      </Localization>
    </Provider>
  );
};
